export const environment = {
  production: false,
  endPoint: 'https://adminapi-test.empathyiq.ie/api/admin/',
  surveyEndPoint: 'https://eiq-internal-surveyapi--test-fycne5fmbjbae6fa.northeurope-01.azurewebsites.net/api/admin/survey/',
  fromNumber: '',
  debug: true,
  refuseMultipleSignup: true,
  researchAssistantEnabled: true,
  domain: 'adminapi-test.empathyiq.ie',
  appName: 'EmpathyIQ - Test',
  logoPath: 'assets/logo/empathyIQ-logomark.svg',
  loginLogoPath: 'assets/logo/empathyIQ-logo-dark.svg',
  appInsights: {
    instrumentationKey: '2aacd178-a333-45d2-9c95-589757325c53'
  }
};
